import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { LivyHelp } from 'src/components/livy/LivyHelp';
import { LivyTheme } from 'src/components/livy/LivyTheme';
import { livyUnavailableMessage, useLivyAccess } from 'src/components/livy/access';
import { useBillingType } from 'src/components/livy/billingType';
import { useEngagement } from 'src/components/livy/LivyGreeting';
import { livyConfig } from 'src/lib/livyTransport';
import { useStore } from 'src/stores';
/**
 * The help center for customers: Livable's help articles for their customer type. The proxy decides what is listed
 * (its reader tier hides staff-only and resident-only articles, and `type` narrows to the customer's billing type).
 * Asking Livy from an article opens Livy's page with the question.
 */
const LivyHelpPageBody = observer(function LivyHelpPageBody() {
  const store = useStore();
  const access = useLivyAccess(store.account.userProfile.userRole);
  const billingType = useBillingType();
  const engagement = useEngagement(access);
  const navigate = useNavigate();
  if (!access || !livyConfig()) {
    return /*#__PURE__*/React.createElement(Box, {
      sx: {
        p: '24px'
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, livyUnavailableMessage));
  }
  return /*#__PURE__*/React.createElement(Paper, {
    variant: "outlined",
    sx: {
      minHeight: '100%',
      borderRadius: 0,
      borderWidth: '0 0 0 1px'
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    sx: {
      px: '16px',
      py: '12px',
      borderBottom: 1,
      borderColor: 'divider'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 15,
      fontWeight: 600
    }
  }, "Knowledge base"), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 11.5,
      color: 'text.secondary'
    }
  }, "How Livable works, step by step")), /*#__PURE__*/React.createElement(Box, {
    sx: {
      maxWidth: 860
    }
  }, /*#__PURE__*/React.createElement(LivyHelp, {
    billingType: billingType(),
    recent: engagement === null || engagement === void 0 ? void 0 : engagement.topics,
    supportFormUrl: engagement === null || engagement === void 0 ? void 0 : engagement.supportFormUrl,
    onAsk: text => navigate('/livy/chat', {
      state: {
        livyAsk: text
      }
    })
  })));
});
export function LivyHelpPage() {
  return /*#__PURE__*/React.createElement(LivyTheme, null, /*#__PURE__*/React.createElement(LivyHelpPageBody, null));
}